export default "__VITE_ASSET__BWdlNNA5__"